<mat-dialog-content>
  <app-screening-criterias-results
    [results]="data.result"
    [runId]="data.runId"
    [editable]="data.editable"
    [isScreeningOne]="data.isScreeningOne"
    [paper]="data.paper"></app-screening-criterias-results>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
